class RejectionHandler {
  static handleReject = (
    // tslint:disable-next-line:no-any
    reject: (reason?: any) => void,
    response: Response
  ) => {
    if (response instanceof Response) {
      return response.json().then(v => {      
        // tslint:disable-next-line:no-string-literal
        return reject(v['Message']);
      });
    }

    return reject(response);
  };
}

export default RejectionHandler;



// WEBPACK FOOTER //
// ./src/Helpers/RejectionHandler.ts